import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import ReactHtmlParser from 'react-html-parser'

import TimeIcon from '../_assets/timer-icon.svg'

import courseLogic from '~/scenes/course/show/logic'

const PriceModalContent = () => {
  const {
    course: { visibleRates, membershipRate }
  } = useValues(courseLogic)

  return (
    <div className='price-modal-content'>
      <div className='visible-rate-container'>
        {visibleRates.map(visibleRate => (
          <div className='visible-rate' key={visibleRate.location}>
            <div className='title'>{visibleRate.title}</div>
            <div className='visible-rates-container'>
              {visibleRate.rates.map(rates => (
                <div className='visible-rate-title-price-container' key={rates.duration}>
                  <div className='rate-icon-title'>
                    <img className='price-icon' alt='price icon' src={TimeIcon} width={14} height={16} />
                    <div className='rate-title'>{rates.title}</div>
                  </div>
                  <div className='rate-price-discount'>
                    <div className='rate-price'>{rates.price}</div>
                    {!!rates.discount && <div className='rate-discount'>{rates.discount}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {membershipRate && (
        <div className='membership-rate'>
          <span>{ReactHtmlParser(membershipRate)}</span>
        </div>
      )}
    </div>
  )
}

export default PriceModalContent
